module.exports = __webpack_public_path__ + "img/close.96808125.png";